import fetchHandler from '@/store/modules/utils/fetchHandler';
import interactionHandler from '@/store/modules/utils/interactionHandler';

export default {
    fetchHandler,
    interactionHandler,
};
